;(() => {
  const history = []

  function chompedHash() {
    return location.hash.replace("#", "")
  }

  let lastKnownHash = chompedHash()

  function onHashChange() {
    const oldHash = lastKnownHash
    const newHash = chompedHash()
    lastKnownHash = newHash

    if (oldHash === newHash) return

    if (newHash === history[history.length - 1]) {
      history.pop()
    } else {
      history.push(oldHash)
    }
  }

  function setHash(newHash) {
    if (newHash === history[history.length - 1]) {
      window.history.back()
    } else {
      window.location.hash = newHash
    }
  }

  function backOrSetHash(fallbackHash) {
    setHash(history[history.length - 1] ?? fallbackHash)
  }

  window.addEventListener("hashchange", onHashChange)
  window.addEventListener("popstate", onHashChange)

  window.HB = window.HB || {}
  window.HB.hashNav = { setHash, backOrSetHash }
})()
